exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-bordered thead th {\n  white-space: nowrap !important;\n}\n.table-bordered td {\n  border: 1px solid #fff;\n}\n.cell-sm {\n  width: 5%;\n}", ""]);

// exports
